webpackJsonp([213720915766396],{

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/givemeacolor.351bd813.png";

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/keyboardist.afe22172.png";

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/savage.e71416ab.png";

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(94);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _typography = __webpack_require__(22);
	
	var _grayPercentage = __webpack_require__(24);
	
	var _grayPercentage2 = _interopRequireDefault(_grayPercentage);
	
	var _keyboardist = __webpack_require__(752);
	
	var _keyboardist2 = _interopRequireDefault(_keyboardist);
	
	var _givemeacolor = __webpack_require__(751);
	
	var _givemeacolor2 = _interopRequireDefault(_givemeacolor);
	
	var _savage = __webpack_require__(754);
	
	var _savage2 = _interopRequireDefault(_savage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var github = function github(name) {
	  return 'https://github.com/soska/' + name;
	};
	
	var Project = function Project(_ref) {
	  var name = _ref.name,
	      link = _ref.link,
	      children = _ref.children;
	
	  return Glamor.createElement(
	    'div',
	    {
	      css: {
	        marginTop: (0, _typography.rhythm)(1),
	        marginBottom: (0, _typography.rhythm)(1),
	        padding: (0, _typography.rhythm)(1),
	        background: 'white',
	        borderRadius: (0, _typography.rhythm)(0.15),
	        boxShadow: 'rgba(0,0,0,.05) 6px 6px 0'
	      }
	    },
	    Glamor.createElement(
	      'a',
	      {
	        href: link,
	        css: {
	          display: 'block',
	          paddingBottom: (0, _typography.rhythm)(0.5),
	          marginBottom: (0, _typography.rhythm)(0.5),
	          borderBottom: '1px solid ' + (0, _grayPercentage2.default)(90)
	        }
	      },
	      name
	    ),
	    Glamor.createElement(
	      'div',
	      null,
	      children
	    )
	  );
	};
	
	var Projects = function Projects() {
	  return Glamor.createElement(
	    'div',
	    null,
	    Glamor.createElement(_reactHelmet2.default, { title: 'Projects | Armando Sosa' }),
	    Glamor.createElement(
	      'h2',
	      null,
	      'Open Source'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Keyboardist', link: github('keyboardist.js') },
	      Glamor.createElement('img', { src: _keyboardist2.default, alt: 'Keyboardist' }),
	      'Easy way to add key shortcuts to your Javascript application.'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'React Keyboardist', link: github('react-keyboardist') },
	      'React wrapper for Keyboardist'
	    ),
	    Glamor.createElement(
	      'h2',
	      null,
	      'Fun Tools'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Give Me A Color', link: 'https://givemeacolor.com' },
	      Glamor.createElement('img', { src: _givemeacolor2.default, alt: 'GiveMeAColor.com' }),
	      'Sometimes one needs a random color to get the inspiration going.'
	    ),
	    Glamor.createElement(
	      Project,
	      { name: 'Savage', link: 'https://savage.now.sh' },
	      Glamor.createElement('img', { src: _savage2.default, alt: 'GiveMeAColor.com' }),
	      'Quick way to turn an SVG file into a React Component.'
	    )
	  );
	};
	exports.default = Projects;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-js-6695924504e28fa705cd.js